import dbflex from "@/util/dbflex";
import Vue from "vue";

var plugin = new Vue();
export default {
    namespaced: true,
    state: {
        tipeAnggran: {
            data: [
                { text: "DPA221", value: "DPA221" },
                { text: "RKA221", value: "RKA221" },
                { text: "DPA1", value: "DPA1" },
                { text: "RKA1", value: "RKA1" },
            ],
        },
        tipeSekolah: {
            data: [
                { text: "Swasta", value: "swasta" },
                { text: "Negeri", value: "negeri" },
            ],
        },
        jenisPejabat: {
            data: [
                { text: "Pejabat Sekolah", value: "sekolah" },
                { text: "Pejabat Daerah", value: "daerah" },
            ],
        },
        tipeGrup: {
            data: [
                { text: "Sekolah", value: "sekolah" },
                { text: "Petugas", value: "petugas" },
            ],
        },
        jenisTransaksi: [
            { text: "Penerimaan", value: "penerimaan" },
            { text: "Belanja", value: "belanja" },
        ],
        discussionStatus: [
            { text: "Terbuka", value: "open" },
            { text: "Dibuka Kembali", value: "reopen" },
            { text: "Tertutup", value: "closed" },
            { text: "Terverifikasi", value: "verified" },
        ],
        bidang: {
            loading: false,
            data: [],
        },
        urusan: {
            loading: false,
            data: [],
        },
        program: {
            loading: false,
            data: [],
        },
        rekeningMaster: {
            loading: false,
            data: [],
        },
        rekening: {
            loading: false,
            data: [],
        },
        sekolah: {
            loading: false,
            data: [],
        },
        pajak: {
            loading: false,
            data: [],
        },
        kegiatan: {
            loading: false,
            data: [],
        },
        tahun: {
            loading: false,
            data: [],
        },
        statusAnggaran: {
            loading: false,
            data: [],
        },
        pejabat: {
            loading: false,
            data: [],
        },
        pengguna: {
            loading: false,
            data: [],
        },
        grup: {
            loading: false,
            data: [],
        },
        label: {
            loading: false,
            data: [],
        },
        kategori: {
            loading: false,
            data: [],
        },
        delegasi: {
            loading: false,
            data: [],
        },
    },
    mutations: {
        isPenggunaLoading(state, loading) {
            state.pengguna.loading = loading;
        },
        resetDataPengguna(state) {
            state.pengguna.data = [];
        },
        setDataPengguna(state, pengguna) {
            state.pengguna.data = pengguna;
        },
        isGrupLoading(state, loading) {
            state.grup.loading = loading;
        },
        resetDataGrup(state) {
            state.grup.data = [];
        },
        setDataGrup(state, grup) {
            state.grup.data = grup;
        },
        isKategoriLoading(state, loading) {
            state.kategori.loading = loading;
        },
        resetDataKategori(state) {
            state.kategori.data = [];
        },
        setDataKategori(state, kategori) {
            state.kategori.data = kategori;
        },
        isLabelLoading(state, loading) {
            state.label.loading = loading;
        },
        resetDataLabel(state) {
            state.label.data = [];
        },
        setDataLabel(state, label) {
            state.label.data = label;
        },
        isBidangLoading(state, loading) {
            state.bidang.loading = loading;
        },
        resetDataBidang(state) {
            state.bidang.data = [];
        },
        setDataBidang(state, bidang) {
            state.bidang.data = bidang;
        },
        isUrusanLoading(state, loading) {
            state.urusan.loading = loading;
        },
        resetDataUrusan(state) {
            state.urusan.data = [];
        },
        setDataUrusan(state, urusan) {
            state.urusan.data = urusan;
        },
        isProgramLoading(state, loading) {
            state.program.loading = loading;
        },
        resetDataProgram(state) {
            state.program.data = [];
        },
        setDataProgram(state, program) {
            state.program.data = program;
        },
        isRekeningLoading(state, loading) {
            state.rekening.loading = loading;
        },
        resetDataRekening(state) {
            state.rekening.data = [];
        },
        setDataRekening(state, rekening) {
            state.rekening.data = rekening;
        },
        isSekolahLoading(state, loading) {
            state.sekolah.loading = loading;
        },
        resetDataSekolah(state) {
            state.sekolah.data = [];
        },
        setDataSekolah(state, sekolah) {
            state.sekolah.data = sekolah;
        },
        isPajakLoading(state, loading) {
            state.pajak.loading = loading;
        },
        resetDataPajak(state) {
            state.pajak.data = [];
        },
        setDataPajak(state, pajak) {
            state.pajak.data = pajak;
        },
        isKegiatanLoading(state, loading) {
            state.kegiatan.loading = loading;
        },
        resetDataKegiatan(state) {
            state.kegiatan.data = [];
        },
        setDataKegiatan(state, kegiatan) {
            state.kegiatan.data = kegiatan;
        },
        isRekeningMasterLoading(state, loading) {
            state.rekeningMaster.loading = loading;
        },
        resetDataRekeningMaster(state) {
            state.rekeningMaster.data = [];
        },
        setDataRekeningMaster(state, rekeningMaster) {
            state.rekeningMaster.data = rekeningMaster;
        },
        isTahunLoading(state, loading) {
            state.tahun.loading = loading;
        },
        resetDataTahun(state) {
            state.tahun.data = [];
        },
        setDataTahun(state, tahun) {
            state.tahun.data = tahun;
        },
        isStatusAnggaranLoading(state, loading) {
            state.statusAnggaran.loading = loading;
        },
        resetDataStatusAnggaran(state) {
            state.statusAnggaran.data = [];
        },
        setDataStatusAnggaran(state, statusAnggaran) {
            state.statusAnggaran.data = statusAnggaran;
        },
        isPejabatLoading(state, loading) {
            state.pejabat.loading = loading;
        },
        resetDataPejabat(state) {
            state.pejabat.data = [];
        },
        setDataPejabat(state, pejabat) {
            state.pejabat.data = pejabat;
        },
        isDelegasiLoading(state, loading) {
            state.delegasi.loading = loading;
        },
        resetDataDelegasi(state) {
            state.delegasi.data = [];
        },
        setDataDelegasi(state, delegasi) {
            state.delegasi.data = delegasi;
        },
    },
    actions: {
        refreshPengguna(context) {
            context.commit("isPenggunaLoading", true);
            context.commit("resetDataPengguna");
            plugin.$axios
                .post("/user/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataPengguna", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isPenggunaLoading", false);
                });
        },
        refreshGrup(context) {
            context.commit("isGrupLoading", true);
            context.commit("resetDataGrup");
            plugin.$axios
                .post("/group/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataGrup", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isGrupLoading", false);
                });
        },
        refreshKategori(context) {
            context.commit("isKategoriLoading", true);
            context.commit("resetDataKategori");
            plugin.$axios
                .post("/discussion/category/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataKategori", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isKategoriLoading", false);
                });
        },
        refreshLabel(context) {
            context.commit("isLabelLoading", true);
            context.commit("resetDataLabel");
            plugin.$axios
                .post("/discussion/label/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataLabel", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isLabelLoading", false);
                });
        },
        refreshBidang(context) {
            context.commit("isBidangLoading", true);
            context.commit("resetDataBidang");
            plugin.$axios
                .post("/administration/bidang/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataBidang", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isBidangLoading", false);
                });
        },
        refreshUrusan(context) {
            context.commit("isUrusanLoading", true);
            context.commit("resetDataUrusan");
            plugin.$axios
                .post("/administration/urusan/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataUrusan", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isUrusanLoading", false);
                });
        },
        refreshProgram(context, payload = "") {
            let p = {},
                filter = new dbflex();

            // constructing filter
            p.Orders = ["Nama"];
            if (payload) filter.eq("IDBidang", payload);

            // generate filter
            p.Filter = filter.get();

            context.commit("isProgramLoading", true);
            context.commit("resetDataProgram");
            plugin.$axios
                .post("/administration/program/list", p)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataProgram", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isProgramLoading", false);
                });
        },
        refreshCurrentProgramKegiatan(context, payload = {}) {
            context.commit("isProgramLoading", true);
            context.commit("isKegiatanLoading", true);

            context.commit("resetDataProgram");
            context.commit("resetDataKegiatan");

            plugin.$axios
                .post("/report/rkas/current_program_kegiatan", payload)
                .then((res) => {
                    const result = res.data;
                    const data = result.Data;
                    context.commit("setDataProgram", data.Program || []);
                    context.commit("setDataKegiatan", data.Kegiatan || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isProgramLoading", false);
                    context.commit("isKegiatanLoading", false);
                });
        },
        refreshRekening({ commit }, payload) {
            let p = {},
                urlEndpoint = "";
            let { type = "", param = {} } = payload;

            switch (type) {
                case "dbflex":
                    urlEndpoint = "/administration/rekening/list";
                    var { limit, keyword = "", level } = param;
                    var filter = new dbflex();

                    if (limit > 0) p.Limit = limit;
                    if (level) filter.eq("Level", level + "");

                    if (keyword.length > 0) {
                        p.Keyword = `*${keyword.toLowerCase()}*`;
                        p.KeywordFields = ["Nama", "Kode"];
                    }

                    p.Filter = filter.get();
                    p.Orders = ["Nama", "Kode"];
                    break;
                case "rkas":
                    urlEndpoint = "/administration/rekening/rkas";
                    p = param;
                    break;
                case "transaction":
                    urlEndpoint = "/administration/rekening/transaction";
                    break;
                default:
                    urlEndpoint = "/administration/rekening/list";
                    break;
            }

            commit("isRekeningLoading", true);
            commit("resetDataRekening");
            plugin.$axios
                .post(urlEndpoint, p)
                .then((res) => {
                    const result = res.data;
                    commit("setDataRekening", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    commit("isRekeningLoading", false);
                });
        },
        refreshSekolah(context, payload = "") {
            let p = {},
                filter = new dbflex();

            // constructing filter
            p.Orders = ["Nama"];
            if (payload) filter.eq("TipeSekolah", payload);

            // generate filter
            p.Filter = filter.get();

            context.commit("isSekolahLoading", true);
            context.commit("resetDataSekolah");
            plugin.$axios
                .post("/administration/sekolah/list", p)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataSekolah", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isSekolahLoading", false);
                });
        },
        refreshPajak(context) {
            context.commit("isPajakLoading", true);
            context.commit("resetDataPajak");
            plugin.$axios
                .post("/administration/pajak/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataPajak", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isPajakLoading", false);
                });
        },
        refreshKegiatan(context, payload = "") {
            let p = {},
                filter = new dbflex();

            // constructing filter
            p.Orders = ["Nama"];
            if (payload) filter.eq("IDProgram", payload);

            // generate filter
            p.Filter = filter.get();

            context.commit("isKegiatanLoading", true);
            context.commit("resetDataKegiatan");
            plugin.$axios
                .post("/administration/kegiatan/list", p)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataKegiatan", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isKegiatanLoading", false);
                });
        },
        refreshRekeningMaster(context) {
            context.commit("isRekeningMasterLoading", true);
            context.commit("resetDataRekeningMaster");
            plugin.$axios
                .post("/administration/rekening/master/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataRekeningMaster", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isRekeningMasterLoading", false);
                });
        },
        refreshTahun(context) {
            context.commit("isTahunLoading", true);
            context.commit("resetDataTahun");
            plugin.$axios
                .post("/administration/tahun/list", {})
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataTahun", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isTahunLoading", false);
                });
        },
        refreshStatusAnggaran(context, payload = 0) {
            let p = {},
                filter = new dbflex();

            // constructing filter
            p.Orders = ["StatusAnggaran"];
            if (payload) filter.eq("Tahun", payload);

            // generate filter
            p.Filter = filter.get();

            context.commit("isStatusAnggaranLoading", true);
            context.commit("resetDataStatusAnggaran");
            plugin.$axios
                .post("/administration/status_anggaran/list", p)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataStatusAnggaran", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isStatusAnggaranLoading", false);
                });
        },
        refreshPejabat(context, payload = {}) {
            let p = {},
                urlEndpoint = "/administration/pejabat/list",
                filter = new dbflex();
            let { type = "", param = {} } = payload;
            let { limit, keyword = "", idSekolah = "" } = param;

            // constructing filter
            p.Orders = ["Nama", "Kode"];
            if (limit > 0) p.Limit = limit;
            if (keyword.length > 0) {
                p.Keyword = `*${keyword.toLowerCase()}*`;
                p.KeywordFields = ["Nama", "Kode"];
            }
            filter.eq("Jenis", type);

            switch (type) {
                case "sekolah":
                    if (idSekolah) filter.eq("IDSekolah", idSekolah);
                    break;
            }

            // generate filter
            p.Filter = filter.get();

            context.commit("isPejabatLoading", true);
            context.commit("resetDataPejabat");
            plugin.$axios
                .post(urlEndpoint, p)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataPejabat", result.Data || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isPejabatLoading", false);
                });
        },
        refreshDelegasi(context, payload = {}) {
            let url = "/user/list";
            if (plugin.$acl.check("isOnlySpitda")) url = "/user/atasan";
            context.commit("isDelegasiLoading", true);
            context.commit("resetDataDelegasi");
            let spitdaGroup = ['spitda', 'kepala_spitda'];
            plugin.$axios
                .post(url, payload)
                .then((res) => {
                    const result = res.data;
                    context.commit("setDataDelegasi", result.Data.filter(g => spitdaGroup.includes(g.GroupID)) || []);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isDelegasiLoading", false);
                });
        }
    },
    getters: {
        penggunaEmpty(state) {
            return state.pengguna.length == 0;
        },
        isPenggunaLoading(state) {
            return state.pengguna.loading;
        },
        grupEmpty(state) {
            return state.grup.length == 0;
        },
        isGrupLoading(state) {
            return state.grup.loading;
        },
        bidangEmpty(state) {
            return state.bidang.length == 0;
        },
        isBidangLoading(state) {
            return state.bidang.loading;
        },
        isUrusanLoading(state) {
            return state.urusan.loading;
        },
        programEmpty(state) {
            return state.program.length == 0;
        },
        isProgramLoading(state) {
            return state.program.loading;
        },
        rekeningEmpty(state) {
            return state.rekening.length == 0;
        },
        isRekeningLoading(state) {
            return state.rekening.loading;
        },
        listRekeningBelanja(state) {
            return state.rekening.data.filter((x) => x.Kode.indexOf("5") == 0);
        },
        listRekeningPenerimaan(state) {
            return state.rekening.data.filter((x) => x.Kode.indexOf("4") == 0);
        },
        sekolahEmpty(state) {
            return state.sekolah.length == 0;
        },
        isSekolahLoading(state) {
            return state.sekolah.loading;
        },
        isKegiatanLoading(state) {
            return state.sekolah.loading;
        },
        rekeningMasterEmpty(state) {
            return state.rekeningMaster.length == 0;
        },
        isRekeningMasterLoading(state) {
            return state.rekeningMaster.loading;
        },
        tahunEmpty(state) {
            return state.tahun.length == 0;
        },
        isTahunLoading(state) {
            return state.tahun.loading;
        },
        statusAnggaranEmpty(state) {
            return state.statusAnggaran.length == 0;
        },
        isStatusAnggaranLoading(state) {
            return state.statusAnggaran.loading;
        },
        kategoriEmpty(state) {
            return state.kategori.length == 0;
        },
        isKategoriLoading(state) {
            return state.kategori.loading;
        },
        labelEmpty(state) {
            return state.label.length == 0;
        },
        isLabelLoading(state) {
            return state.label.loading;
        },
        pejabatEmpty(state) {
            return state.statusAnggaran.length == 0;
        },
        isPejabatLoading(state) {
            return state.pejabat.loading;
        },
        delegasiEmpty(state) {
            return state.statusAnggaran.length == 0;
        },
        isDelegasiLoading(state) {
            return state.delegasi.loading;
        },
    },
};
